import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";

export interface IDataUpdateOrganizationProfile {
    id: string,
    userId: string,
    userType: number,
    organizationId: string,

    gender: number,
    email?: string,
    lastName: string,
    firstName: string,
    phoneNumber?: string,
    dateOfBirth: number | string,

    idCardNo: string,
    idCardIssuedPlace: string,
    idCardIssuedDate: number | string,
    socialInsuranceCode: string,
    employmentDate: number | string,
    extraInformation?: { description?: string },

    passportNo?: string;
    nationality?: string;
    passportIssuedPlace?: string;
    passportExpiredDate?: number | string;
}

const ProfileService = {
    async getUserInfo() {
        const result = await IdentityClient().get(Constants.ApiPath.PROFILE.GET_USER_INFO);
        return result.data.result;
    },

    async getUserAuthorization(data: { serviceCode: string, organizationId?: string }) {
        const result = await IdentityClient().get(Constants.ApiPath.PROFILE.GET_USER_AUTHORIZATION, {
            params: {
                serviceCode: data.serviceCode,
                organizationId: data.organizationId,
            }
        });
        return result.data.result;
    },

    async updateUserProfile(data: {
        email: string,
        gender: number,
        fullName: string,
        userName: string,
        phoneNumber: string,
        birthDate: number | string,
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.UPDATE_USER_PROFILE, data);
        return result.data;
    },

    async updateOrganizationProfile(data: IDataUpdateOrganizationProfile[]) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.UPDATE_ORGANIZATION_PROFILE, data);
        return result.data;
    },

    async updateAvatar(data: {
        avatarId: string,
        avatarUrl: string
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.CHANGE_AVATAR, data);
        return result.data;
    },

    async changePassword(data: {
        oldPassword: string,
        newPassword: string,
        confirmPassword: string,
        tenantCode: string,
        serviceCode: string
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.CHANGE_PASSWORD, data);
        return result.data;
    },

    async getPhoneNumberOTP(data: {
        phoneNumber: string,
        tenantCode: string,
        serviceCode: string
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.GET_CHANGE_PHONE_NUMBER_OTP, data);
        return result.data;
    },

    async changePhoneNumber(data: {
        otp: string,
        phoneNumber: string,
        tenantCode: string,
        serviceCode: string,
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.CHANGE_PHONE_NUMBER, data);
        return result.data;
    },

    async getChangeEmailOTP(data: {
        email: string,
        tenantCode: string,
        serviceCode: string
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.GET_CHANGE_EMAIL_OTP, data);
        return result.data;
    },

    async changeEmail(data: {
        otp: string,
        email: string,
        tenantCode: string,
        serviceCode: string,
    }) {
        const result = await IdentityClient().post(Constants.ApiPath.PROFILE.CHANGE_EMAIL, data);
        return result.data;
    },
}

export default ProfileService